export const TITLES = {
	serviceDetailsNotShowOnTheScreens: 'Service Details Not Shown On The Screens',
	userDetailsShownWhenTheBackendAsks: 'User Details Shown When The Backend Asks',
	cashierSetupDetails: 'Cashier Setup Details',
	userDetails: 'User Details',
	theming: 'Theming',
};
